import axios from "axios";
import { Dispatch } from "redux";
import baseUrl from "../../../Url";
import { setupInterceptorsTo } from "../../Authentication/Interceptors";
import {
  LogOutActionTypes,
  ADD_PATIENT_TEAM_FAIL,
  ADD_PATIENT_TEAM_LOADING,
  ADD_PATIENT_TEAM_SUCCESS,
} from "./ActionTypes";
import { AddPatientTeamReq, AddPatientTeamResponse } from "./Model";
import { headers } from "../../../components/Utility";

export const addPatientTeam = (payload: AddPatientTeamReq) => {
  return function (dispatch: Dispatch<LogOutActionTypes>) {
    dispatch({
      type: ADD_PATIENT_TEAM_LOADING,
    });
    setupInterceptorsTo(axios)
      .post(
        baseUrl.baseUrl + `/patientapp/api/patientTeam/add_patientTeam_request`,
        payload,
        {
          headers: headers,
        }
      )
      .then((res) => {
        dispatch({
          type: ADD_PATIENT_TEAM_SUCCESS,
          payload: res.data,
          errRes: "",
        });
      })
      .catch((error) => {
        dispatch({
          type: ADD_PATIENT_TEAM_FAIL,
          payload: {} as AddPatientTeamResponse,
          errRes: error.response.data.message,
        });
      });
  };
};
